/**
 * FastSpring configuration constants
 * @constant
 */
const CONFIG = {
  SCRIPT_ID: 'fsc-api',
  STOREFRONTS: {
    ec: {
      default: process.env.ISV_STOREFRONT_URL,
    },
    cc: {
      default: process.env.CC_CONTEXTUAL_STOREFRONT_URL,
    },
  },
  POPUP_CALLBACK: 'dataPopupClosed', // Centralize callback name
};

const getCloudType = (appConfig) => {
  if (!appConfig) return 'cc';
  const cloud = typeof appConfig === 'object' ? appConfig.cloud : null;
  return cloud === 'ec' ? 'ec' : 'cc';
};

const getStorefrontUrl = (cloud, appType) => {
  const cloudConfig = CONFIG.STOREFRONTS[cloud];
  if (!cloudConfig) return null;
  const url = cloudConfig[appType?.toUpperCase()] || cloudConfig.default;
  return url;
};

const loadFastSpringScript = (storefrontUrl, cloud) => {
  return new Promise((resolve, reject) => {
    // Check if script already loaded with same storefront
    const existing = document.getElementById(CONFIG.SCRIPT_ID);
    if (existing && existing.getAttribute('data-storefront') === storefrontUrl) {
      resolve();
      return;
    }
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = CONFIG.SCRIPT_ID;
    script.type = 'text/javascript';
    script.src = 'https://sbl.onfastspring.com/sbl/1.0.5/fastspring-builder.min.js';
    script.setAttribute('data-storefront', storefrontUrl);
    if (cloud === 'cc') script.setAttribute('data-popup-closed', CONFIG.POPUP_CALLBACK);

    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load FastSpring script'));

    document.head.appendChild(script);
  });
};

const setGlobalFastSpringConfig = (cloud, storefrontUrl, contextual) => {
  window.FastSpringConfig = {
    cloudType: cloud,
    storefrontUrl,
    contextual,
    getStorefrontUrl: () => storefrontUrl,
    isContextualEnabled: () => window.FastSpringConfig?.contextual || false,
    getCloudType: () => cloud,
    isReady: () => !!(window.fastspring && window.fastspring.builder),
  };
};

export const configureFastSpring = async (appConfig = null) => {
  const cloud = getCloudType(appConfig);
  const appType = typeof appConfig === 'string' ? appConfig : appConfig?.appType;
  const storefrontUrl = getStorefrontUrl(cloud, appType);

  if (cloud === 'cc' && !storefrontUrl) {
    setGlobalFastSpringConfig(cloud, null, false);
    return;
  }

  await loadFastSpringScript(storefrontUrl, cloud);
  setGlobalFastSpringConfig(cloud, storefrontUrl, true);
};

export const initializeFastSpring = async (appConfig) => {
  const existingScript = document.getElementById(CONFIG.SCRIPT_ID);
  if (existingScript) existingScript.remove();
  await configureFastSpring(appConfig);
};

if (typeof window !== 'undefined') window.initializeFastSpring = initializeFastSpring;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => configureFastSpring());
} else {
  configureFastSpring();
}
